module.exports = __webpack_public_path__ + "img/LOGO Vinqlo novo.baf82cfb.png";